export default __webpack_public_path__ + "static/media/evreux9.4ca2828a.jpg";